(function () {
  const PDP_SCOPE = '.main_product_section';
  const BUTTONS_APPLE_PAY_ONLY_CLASS = 'product-form__buttons--apple-pay-only';

  const NON_APPLE_PAY_TAGS = new Set([
    'SHOPIFY-PAYPAL-BUTTON',
    'SHOP-PAY-WALLET-BUTTON',
    'GOOGLE-PAY-BUTTON',
    'PAYPAL-BUTTON',
  ]);

  const NON_APPLE_PAY_SELECTORS = [
    'shopify-paypal-button',
    'shop-pay-wallet-button',
    'google-pay-button',
    'paypal-button',
    '.shopify-payment-button__more-options',
    '[data-testid="ShopifyPay-button"]',
    '[data-testid="shop-pay-button"]',
  ];

  function isApplePayNode(node) {
    if (!node) return false;

    const tagName = node.tagName || '';
    if (tagName.includes('APPLE-PAY')) return true;

    const label = (
      node.getAttribute?.('aria-label') ||
      node.getAttribute?.('title') ||
      node.textContent ||
      ''
    ).toLowerCase();

    return label.includes('apple pay') || !!node.closest?.('apple-pay-button, shopify-apple-pay-button');
  }

  function hideNode(node) {
    if (!node || isApplePayNode(node)) return false;
    node.setAttribute('hidden', '');
    node.style.display = 'none';
    return true;
  }

  function getProductFormButtonsForScope(scope) {
    if (!scope) return [];

    if (scope.classList?.contains('product-form__buttons')) {
      return [scope];
    }

    const fromScope = scope.querySelectorAll?.('.product-form__buttons');
    if (fromScope?.length) {
      return [...fromScope];
    }

    const parentButtons = scope.closest?.('.product-form__buttons');
    return parentButtons ? [parentButtons] : [];
  }

  function hasVisibleApplePay(container) {
    if (!container) return false;
    let hasApple = false;
    walkTrees(container, (node) => {
      if (node.nodeType === Node.ELEMENT_NODE && isApplePayNode(node)) {
        if (!node.hasAttribute('hidden') && node.style.display !== 'none') {
          hasApple = true;
        }
      }
    });
    return hasApple;
  }

  function syncApplePayOnlyButtonsClass(scope, didHideAny) {
    getProductFormButtonsForScope(scope).forEach((buttonsEl) => {
      const paymentEl = buttonsEl.querySelector('.shopify-payment-button, shopify-accelerated-checkout');
      const hasHiddenWallets = !!buttonsEl.querySelector('.shopify-payment-button [hidden]');
      if (didHideAny || hasHiddenWallets) {
        buttonsEl.classList.add(BUTTONS_APPLE_PAY_ONLY_CLASS);
      }
      if (paymentEl) {
        const hasApple = hasVisibleApplePay(paymentEl);
        if (!hasApple) {
          paymentEl.setAttribute('hidden', '');
          paymentEl.style.setProperty('display', 'none', 'important');
          paymentEl.classList.add('hidden');
        } else {
          paymentEl.removeAttribute('hidden');
          paymentEl.style.removeProperty('display');
          paymentEl.classList.remove('hidden');
        }
      }
    });
  }

  function walkTrees(root, callback) {
    if (!root) return;
    callback(root);

    root.querySelectorAll('*').forEach((element) => {
      callback(element);
      if (element.shadowRoot) {
        walkTrees(element.shadowRoot, callback);
      }
    });
  }

  function hideNonApplePayWallets(scope) {
    if (!scope) return false;

    let didHide = false;
    const hideAndTrack = (node) => {
      if (hideNode(node)) didHide = true;
    };

    NON_APPLE_PAY_SELECTORS.forEach((selector) => {
      scope.querySelectorAll(selector).forEach(hideAndTrack);
    });

    walkTrees(scope, (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;

      if (NON_APPLE_PAY_TAGS.has(node.tagName)) {
        hideAndTrack(node);
        return;
      }

      if (node.matches?.('.shopify-payment-button__button, [role="button"]') && !isApplePayNode(node)) {
        const label = (
          node.getAttribute('aria-label') ||
          node.textContent ||
          ''
        ).toLowerCase();

        const isOtherWallet =
          label.includes('shop pay') ||
          label.includes('shopify pay') ||
          label.includes('google pay') ||
          label.includes('paypal') ||
          node.classList.contains('shopify-payment-button__button--branded');

        if (isOtherWallet) {
          hideAndTrack(node);
        }
      }
    });

    return didHide;
  }

  function observePaymentButtons(scope) {
    const containers = scope.querySelectorAll(
      '.product-form__buttons, .shopify-payment-button, shopify-accelerated-checkout'
    );

    containers.forEach((container) => {
      const didHide = hideNonApplePayWallets(container);
      syncApplePayOnlyButtonsClass(container, didHide);

      if (container.__applePayObserver) return;

      const observer = new MutationObserver(() => {
        const didHide = hideNonApplePayWallets(container);
        syncApplePayOnlyButtonsClass(container, didHide);
      });
      observer.observe(container, { childList: true, subtree: true });
      container.__applePayObserver = observer;
    });

    scope.querySelectorAll('shopify-accelerated-checkout').forEach((checkout) => {
      if (checkout.shadowRoot && !checkout.__applePayShadowObserver) {
        const shadowObserver = new MutationObserver(() => {
          const didHide = hideNonApplePayWallets(scope);
          syncApplePayOnlyButtonsClass(scope, didHide);
        });
        shadowObserver.observe(checkout.shadowRoot, { childList: true, subtree: true });
        checkout.__applePayShadowObserver = shadowObserver;
      }
    });
  }

  function initApplePayOnly() {
    document.querySelectorAll(PDP_SCOPE).forEach(observePaymentButtons);
  }

  document.addEventListener('DOMContentLoaded', initApplePayOnly);
  document.addEventListener('product-info:loaded', initApplePayOnly);

  if (window.Shopify?.PaymentButton?.init) {
    const originalInit = window.Shopify.PaymentButton.init.bind(window.Shopify.PaymentButton);
    window.Shopify.PaymentButton.init = function (...args) {
      const result = originalInit(...args);
      initApplePayOnly();
      return result;
    };
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(initApplePayOnly, 50);
    });
  }

  initApplePayOnly();
})();
